import { render, staticRenderFns } from "./MaterialDetailModal.vue?vue&type=template&id=27ff6732&scoped=true"
import script from "./MaterialDetailModal.vue?vue&type=script&lang=js"
export * from "./MaterialDetailModal.vue?vue&type=script&lang=js"
import style0 from "./MaterialDetailModal.vue?vue&type=style&index=0&id=27ff6732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ff6732",
  null
  
)

export default component.exports